import { render, staticRenderFns } from "./MatterList.vue?vue&type=template&id=4f7c38a4"
import script from "./MatterList.vue?vue&type=script&lang=js"
export * from "./MatterList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports